import script from "./BaseIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseIcon.vue?vue&type=script&setup=true&lang=js"

import "./BaseIcon.vue?vue&type=style&index=0&id=0a2c178b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a2c178b"]])

export default __exports__